module.exports = __webpack_public_path__ + "static/media/logoutIcon.de2ab15e.svg";